@if (!showFallback()) {
  <img
    [src]="logoPath()"
    [alt]="logoAlt()"
    [ngClass]="logoClasses()"
    [ngStyle]="{ width: logoWidth(), height: logoHeight() }"
    [attr.role]="clickable() ? 'button' : null"
    [attr.tabindex]="clickable() ? tabIndex() : null"
    [attr.aria-label]="ariaLabel() || logoAlt()"
    class="hx-logo__image"
    (error)="onImageError($event)" />
} @else {
  <div class="hx-logo__fallback" [ngClass]="logoClasses()">
    <span>ComplexCare Solutions</span>
  </div>
}
